/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */

const { getOwnPropertyDescriptor } = Object;

const DocumentPrototypeActiveElement: (this: Document) => Element | null = getOwnPropertyDescriptor(
  Document.prototype,
  'activeElement'
)!.get!;

const elementFromPoint: (x: number, y: number) => Element | null = Document.prototype.elementFromPoint;

// defaultView can be null when a document has no browsing context. For example, the owner document
// of a node in a template doesn't have a default view: https://jsfiddle.net/hv9z0q5a/
const defaultViewGetter: (this: Document) => Window | null = getOwnPropertyDescriptor(
  Document.prototype,
  'defaultView'
)!.get!;

const {
  createComment,
  querySelector,
  querySelectorAll,
  getElementById,
  getElementsByName,
  getElementsByClassName,
  getElementsByTagName,
  getElementsByTagNameNS,
} = Document.prototype;

export {
  elementFromPoint,
  createComment,
  DocumentPrototypeActiveElement,
  querySelector,
  querySelectorAll,
  getElementById,
  getElementsByClassName,
  getElementsByName,
  getElementsByTagName,
  getElementsByTagNameNS,
  defaultViewGetter,
};
